// extracted by mini-css-extract-plugin
export default {"sidebar":"reservations-list__sidebar__MZHxB"};